// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"1516f4fd","84":"475a7855","282":"979445dd","356":"84bd6ab8","606":"a6524af7","640":"3e1ecdbb","883":"87691eb7"}[chunkId] + ".chunk.js";
};